export function isMetaInAppBrowser(userAgent = navigator.userAgent): boolean {
  return /Instagram|FBAN|FBAV|FB_IAB|FB4A|FBIOS/i.test(userAgent);
}

